import { useState } from 'react';
import { TmdxAvatar, Tooltip } from '@ds';
import { uniqBy } from 'lodash-es';
import { AssignedUsersByGroup, CaseResourceCombined } from '@/api/apis/case';
import { getFullTeam } from './utils';

type ResourcesFooterProps = {
  resources: CaseResourceCombined[];
  assignedEmployees: AssignedUsersByGroup;
  onClick: () => void;
};

export const ResourcesFooter = ({ resources, assignedEmployees, onClick }: ResourcesFooterProps) => {
  const [hoveredId, setHoveredId] = useState<string | null>(null);

  const fullTeam = uniqBy(getFullTeam(resources, assignedEmployees), 'id').filter((r) => !!r.employeeId);
  const visibleTeam = fullTeam.slice(0, 3);
  const hiddenCount = Math.max(fullTeam.length - 3, 0);

  return (
    <div className="relative isolate flex flex-1 w-full overflow-visible">
      <button
        type="button"
        className="relative isolate flex items-center overflow-visible bg-transparent p-0 border-none outline-none"
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
      >
        {visibleTeam.map((r, index) => {
          const isHovered = hoveredId === r.id;

          return (
            <div
              key={`${r.id}_${r.roleOnCase}`}
              className="relative overflow-visible"
              style={{
                marginLeft: index === 0 ? 0 : -8,
                zIndex: isHovered ? 1000 : index + 1,
              }}
              onMouseEnter={() => setHoveredId(r.id)}
              onMouseLeave={() => setHoveredId((current) => (current === r.id ? null : current))}
              onFocus={() => setHoveredId(r.id)}
              onBlur={() => setHoveredId((current) => (current === r.id ? null : current))}
            >
              <Tooltip
                placement="top"
                content={r.name}
                classNames={{
                  content: 'px-3 text-nowrap',
                }}
              >
                <div
                  className={`
                    relative cursor-pointer overflow-visible
                    transition-transform duration-150 ease-out
                    ${isHovered ? 'scale-105' : 'scale-100'}
                  `}
                >
                  <TmdxAvatar
                    name={r.name}
                    size="md"
                    src={r.photo}
                    className={`
                      transition-all duration-150 ease-out
                      ${isHovered ? 'ring-1 ring-white' : 'ring-0 ring-transparent'}
                    `}
                  />
                </div>
              </Tooltip>
            </div>
          );
        })}

        {hiddenCount > 0 ? <p className="text-m-r text-base-10 ml-1">+{hiddenCount}</p> : null}
      </button>
    </div>
  );
};
